(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* =========================================================
     Announcement bar height → CSS var (robust)
     ========================================================= */
  const setAnnouncementBarHeight = () => {
    const bars = Array.from(document.querySelectorAll('.announcement-bar'));
    const bar = bars.find(el => el && el.offsetParent !== null) || bars[0];

    const h = bar ? Math.max(bar.offsetHeight || 0, Math.round(bar.getBoundingClientRect().height || 0)) : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', `${h}px`);
  };

  const scheduleAnnouncementUpdate = () => {
    requestAnimationFrame(() => requestAnimationFrame(setAnnouncementBarHeight));
  };

  document.addEventListener('DOMContentLoaded', scheduleAnnouncementUpdate);
  window.addEventListener('load', scheduleAnnouncementUpdate);
  window.addEventListener('resize', scheduleAnnouncementUpdate, { passive: true });
  window.addEventListener('orientationchange', scheduleAnnouncementUpdate);

  // If announcement bar changes height dynamically (e.g. rotating text), observe
  document.addEventListener('DOMContentLoaded', () => {
    const bars = Array.from(document.querySelectorAll('.announcement-bar'));
    const bar = bars.find(el => el && el.offsetParent !== null) || bars[0];
    if (!bar || typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(() => scheduleAnnouncementUpdate());
    ro.observe(bar);
  });

  /* =========================================================
     Transparent header: lightweight "is-solid" toggle
     - No interval
     - No expensive elementsFromPoint loop
     ========================================================= */
  const initTransparentHeader = () => {
    const sectionHeader = document.querySelector('.section-header');
    const wrapper = document.querySelector('.header-wrapper');
    if (!sectionHeader || !wrapper) return;

    const enabled = wrapper.dataset.transparentHeader === 'true';
    if (!enabled) return;

    const onScroll = () => {
      // しきい値は必要なら調整：0 / 10 / header height など
      sectionHeader.classList.toggle('is-solid', window.scrollY > 10);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  document.addEventListener('DOMContentLoaded', initTransparentHeader);

  /* =========================================================
     Dawn StickyHeader (original, keep)
     ========================================================= */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
